import css from './standart.module.css'
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { fetchCSRFToken, getCSRFToken } from '../../lib/csrf';

const Policies = ({ authUser }) => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const [showLangPopup, setShowLangPopup] = useState(false);
    const [loading, setLoading] = useState(false);

    const languages = [
        { code: "en", label: "English", flag: "🇬🇧" },
        { code: "uk", label: "Українська", flag: "🇺🇦" },
        { code: "pl", label: "Polski", flag: "🇵🇱" },
    ];

    const changeLanguage = async (lang) => {
        setLoading(true);
        try {
            i18n.changeLanguage(lang);
            localStorage.setItem("selectedLanguage", lang);

            if (authUser && authUser.isAuthenticated === true) {
                let csrfToken = getCSRFToken();
                if (!csrfToken) {
                    await fetchCSRFToken();
                    csrfToken = getCSRFToken();
                }

                await axios.patch(
                    "/api/v1/user-profile/current",
                    { language: lang },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "X-CSRFToken": csrfToken,
                        },
                        withCredentials: true,
                    }
                );
            }

            setShowLangPopup(false);
        } catch (error) {
            console.error("Error changing language:", error.response?.data || error);
            setShowLangPopup(false);
        } finally {
            setLoading(false);
        }
    };

    const getCurrentLanguage = () => {
        return languages.find(lang => lang.code === i18n.language) || languages[0];
    };

    // Close popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest(`.${css.langSwitch}`)) {
                setShowLangPopup(false);
            }
        };

        if (showLangPopup) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showLangPopup]);

    return (
        <div className={css.polContainer}>
            <div className={css.rights}>
                <p>© 2026 AI Lingua. {t("All rights reserved")}.</p>
            </div>
            <div className={css.polLinks}>
                   <a className={`${css.polLink}`} href="tel:+380682507477">+380682507477</a>
                <a
                    href="/termsOfUse"
                    className={`${css.polLink} ${location.pathname === '/termsOfUse' ? css.activeLink : ''}`}
                    onClick={(e) => {
                        if (location.pathname === '/termsOfUse') {
                            e.preventDefault();
                        }
                    }}
                >
                    {t("Terms of Use")}
                </a>
                <a
                    href="/privacy"
                    className={`${css.polLink} ${location.pathname === '/privacy' ? css.activeLink : ''}`}
                    onClick={(e) => {
                        if (location.pathname === '/privacy') {
                            e.preventDefault();
                        }
                    }}
                >
                    {t("Privacy Policy")}
                </a>
                <a
                    href="/cancelAndRefund"
                    className={`${css.polLink} ${location.pathname === '/cancelAndRefund' ? css.activeLink : ''}`}
                    onClick={(e) => {
                        if (location.pathname === '/cancelAndRefund') {
                            e.preventDefault();
                        }
                    }}
                >
                    {t("Cancel & Refund Policy")}
                </a>
            </div>
            
        </div>
    )
}

export default Policies